// @flow
import { httpGet } from '../helpers/helpers.api';

export function getAppConfig(platform: string, config: string): Promise<Response> {
    return httpGet(`apps/${platform}/${config}`, false, false);
}



// WEBPACK FOOTER //
// ./src/core/api/app/app.api.js